import React from "react";
import {Nav, Tab, Card} from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import UndeadLogo from '../../Assets/UNDEAD_ES_Logo.png'
import ReiChibi from '../../Assets/Image/(A_Place_Close_to_the_Night_Sky)_Rei_Sakuma_Chibi.webp'
import ReiSound from '../../Assets/Sound/vo_rei_bm_skill_3.mp3'
import ClickMeAnimation from "../Fun/ChibiButton";
import ReiHead from '../../Assets/Image/rei_head.png'

function RulesCard() {
  return (
    <Card className="box-card">
    <Tab.Container  id="rules-page" defaultActiveKey="Rules">
          <Nav variant="pills" fill className="navi-custom">
            <Nav.Item>
              <Nav.Link eventKey="Rules">Rules</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="BYF">BYF / DNI</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Tags">Tags</Nav.Link>
            </Nav.Item>
          </Nav>
    <Tab.Content>
            <Tab.Pane eventKey="Rules">
      <Card.Body>
        <div className="rules">
          <p><strong>I will not follow back if:</strong></p>
          <ul className="bulletsCustom">
            <li>you're looking for follow backs</li>
            <li>you're under 16</li>
          </ul>
          <p><strong>Ask before following if:</strong></p>
          <ul className="bulletsCustom">
            <li>you don't like idol fandoms</li>
            <li>you ID with Aine Kisaragi</li>
          </ul>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>

    <Tab.Content>
    <Tab.Pane eventKey="BYF">
      <Card.Body>
      <div className="rules">
          <p><strong>Do not follow if:</strong></p>
          <ul className="bulletsCustom">
            <li>you hate the pokemon Raichu</li>
            <li>you hate/bash characters</li>
            <li>you want to cause drama</li>
            <li>you steal art, including the usage of AI art</li>
            <li>you are racist, homophobic, or transphobic</li>
            <li>you promote hateful or violent rhetoric</li>
          </ul>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    <Tab.Content>
    <Tab.Pane eventKey="Tags">
      <Card.Body>
      <div className="rules">
      <p><strong>Please tag if we are mutuals:</strong></p>
          <ul className="bulletsCustom">
            <li>Gore</li>
            <li>Body Horror</li>
            <li>Neck trauma</li>
          </ul>
        </div>
      </Card.Body>
      </Tab.Pane>
    </Tab.Content>
    </Tab.Container>
    <div className="profileFooter">
        <Row>
        <Col xs={4}>
        <img className="logo" src={UndeadLogo}/>
        </Col>
        <Col xs={8}>
        <ClickMeAnimation head={ReiHead} img={ReiChibi} sound={ReiSound}/>
        </Col>
        </Row>
    </div>
    </Card>
  );
}

export default RulesCard;

